var _rect, _rect2, _path, _path2, _path3, _path4, _rect3, _rect4, _rect5, _rect6, _rect7, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInstall6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 160,
    viewBox: "0 0 312 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80.5,
    y: 29.5,
    width: 151,
    height: 88,
    rx: 2.5,
    fill: "white",
    stroke: "#909090"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 82.5,
    y: 31.5,
    width: 147,
    height: 84,
    rx: 1.5,
    fill: "white",
    stroke: "#909090"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149 74H162",
    stroke: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.586 70.0294L161.849 73.2929C162.24 73.6834 162.24 74.3166 161.849 74.7071L158.586 77.9706",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104 117.5H95.2727L88 130.5H91.3939L104 117.5Z",
    stroke: "#909090"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M206 117.5H214.727L222 130.5H218.606L206 117.5Z",
    stroke: "#909090"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 54,
    width: 18,
    height: 18,
    rx: 4,
    stroke: "#13AE67"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 76,
    width: 18,
    height: 18,
    rx: 4,
    stroke: "#13AE67"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 54,
    width: 18,
    height: 18,
    rx: 4,
    stroke: "#13AE67"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 76,
    width: 18,
    height: 18,
    rx: 4,
    stroke: "#13AE67"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 55,
    width: 40,
    height: 40,
    rx: 4,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5323_44619)",
    filter: "url(#filter0_d_5323_44619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.824 75.9525H190.342L190.136 76.6793H188.804L190.391 72.2766H191.815L193.402 76.6793H192.035L191.824 75.9525H191.824ZM191.554 75.0006L191.088 73.4177L190.626 75.0006H191.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.751 73.4896H194.848V74.0121C194.954 73.7862 195.063 73.6303 195.175 73.5451C195.288 73.4599 195.426 73.4172 195.592 73.4172C195.757 73.4172 195.953 73.4736 196.159 73.5854L195.796 74.4562C195.658 74.3961 195.549 74.3659 195.468 74.3659C195.314 74.3659 195.195 74.4319 195.11 74.5643C194.989 74.7504 194.929 75.0987 194.929 75.6092V76.6783H193.751V73.4892V73.4896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.066 72.2766V73.4896H198.712V74.3847H198.066V75.5148C198.066 75.6509 198.079 75.7407 198.104 75.7847C198.142 75.8525 198.209 75.8864 198.305 75.8864C198.392 75.8864 198.513 75.8603 198.668 75.8085L198.755 76.6522C198.464 76.7182 198.193 76.7512 197.942 76.7512C197.65 76.7512 197.435 76.7123 197.297 76.6343C197.158 76.5564 197.057 76.4377 196.99 76.2787C196.924 76.1197 196.89 75.8621 196.89 75.5065V74.3847H196.458V73.4896H196.89V72.904L198.066 72.2761L198.066 72.2766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 79.8066L190.242 79.7255C190.269 79.9359 190.324 80.0958 190.406 80.2063C190.54 80.3845 190.732 80.4734 190.982 80.4734C191.168 80.4734 191.312 80.4281 191.413 80.3369C191.514 80.2461 191.564 80.1403 191.564 80.0202C191.564 79.9001 191.516 79.8039 191.42 79.7141C191.324 79.6238 191.101 79.539 190.752 79.4588C190.179 79.3245 189.771 79.1463 189.527 78.9245C189.281 78.7022 189.158 78.419 189.158 78.0744C189.158 77.848 189.221 77.6344 189.347 77.4332C189.473 77.232 189.662 77.0739 189.915 76.9589C190.167 76.8439 190.513 76.7861 190.953 76.7861C191.493 76.7861 191.905 76.8906 192.188 77.1001C192.471 77.3095 192.64 77.6422 192.694 78.0986L191.464 78.1738C191.431 77.9754 191.362 77.8315 191.258 77.7412C191.153 77.6509 191.008 77.606 190.824 77.606C190.672 77.606 190.558 77.6394 190.481 77.7064C190.404 77.7737 190.366 77.8553 190.366 77.9511C190.366 78.0212 190.398 78.0844 190.461 78.1403C190.522 78.1985 190.669 78.2526 190.899 78.3026C191.469 78.4304 191.878 78.5601 192.125 78.6912C192.372 78.8227 192.551 78.9854 192.664 79.1793C192.776 79.3736 192.832 79.5908 192.832 79.8309C192.832 80.1132 192.757 80.3735 192.607 80.6118C192.457 80.8501 192.248 81.0307 191.979 81.154C191.71 81.2773 191.371 81.3387 190.962 81.3387C190.244 81.3387 189.746 81.1943 189.469 80.9061C189.193 80.6178 189.036 80.2512 189 79.8071V79.8066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.825 76.8605V78.0736H195.47V78.9686H194.825V80.0987C194.825 80.2344 194.838 80.3247 194.863 80.3682C194.901 80.436 194.968 80.4704 195.064 80.4704C195.151 80.4704 195.272 80.4443 195.427 80.3925L195.513 81.2362C195.223 81.3022 194.952 81.3352 194.701 81.3352C194.409 81.3352 194.194 81.2962 194.056 81.2178C193.917 81.1399 193.815 81.0217 193.749 80.8622C193.682 80.7032 193.649 80.4456 193.649 80.09V78.9682H193.217V78.0731H193.649V77.4875L194.825 76.8596L194.825 76.8605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.977 78.0741H201.074V78.5966C201.18 78.3702 201.289 78.2148 201.402 78.1296C201.514 78.0448 201.652 78.0022 201.818 78.0022C201.983 78.0022 202.18 78.0581 202.385 78.1704L202.023 79.0411C201.884 78.9811 201.775 78.9508 201.694 78.9508C201.541 78.9508 201.421 79.0168 201.337 79.1493C201.216 79.3353 201.155 79.6836 201.155 80.1941V81.2633H199.977V78.0741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.59 78.074H203.827L204.458 80.1972L205.044 78.074H206.2L204.986 81.4817C204.848 81.8704 204.707 82.1329 204.563 82.2691C204.359 82.4611 204.049 82.5578 203.632 82.5578C203.463 82.5578 203.202 82.5339 202.849 82.4858L202.757 81.633C202.926 81.6889 203.114 81.7168 203.322 81.7168C203.46 81.7168 203.572 81.6838 203.657 81.6174C203.743 81.5514 203.815 81.4332 203.874 81.2627L202.59 78.074H202.59Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.643 81.2911C198.521 81.2911 199.234 80.5486 199.234 79.6326C199.234 78.7167 198.521 77.9741 197.643 77.9741C196.764 77.9741 196.052 78.7167 196.052 79.6326C196.052 80.5486 196.764 81.2911 197.643 81.2911Z",
    fill: "#13AE67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.245 67.6914H191.183C191.565 67.6914 191.874 67.7455 192.11 67.8536C192.345 67.9618 192.539 68.1167 192.693 68.3192C192.847 68.5213 192.958 68.7564 193.027 69.025C193.096 69.2935 193.131 69.5777 193.131 69.8779C193.131 70.348 193.079 70.7133 192.977 70.9722C192.874 71.2316 192.732 71.4488 192.549 71.6239C192.367 71.799 192.171 71.9158 191.962 71.974C191.675 72.0542 191.416 72.0941 191.184 72.0941H189.245V67.6914H189.245ZM190.55 68.6886V71.0941H190.87C191.142 71.0941 191.336 71.0625 191.452 70.9993C191.567 70.936 191.657 70.826 191.723 70.6688C191.788 70.5116 191.82 70.2573 191.82 69.9049C191.82 69.4384 191.747 69.1189 191.602 68.9471C191.455 68.7748 191.214 68.6886 190.876 68.6886H190.55H190.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.926 69.9379L193.805 69.8146C193.847 69.6102 193.908 69.4494 193.988 69.3325C194.067 69.2152 194.182 69.1139 194.332 69.0277C194.439 68.9659 194.587 68.9178 194.776 68.8834C194.964 68.8495 195.168 68.8325 195.386 68.8325C195.738 68.8325 196.02 68.8531 196.234 68.8939C196.447 68.9352 196.624 69.0204 196.766 69.151C196.866 69.2413 196.945 69.3687 197.003 69.5337C197.06 69.6987 197.089 69.8568 197.089 70.0066V71.4149C197.089 71.5652 197.098 71.6826 197.116 71.7678C197.135 71.853 197.174 71.9616 197.236 72.0936H196.135C196.091 72.0116 196.062 71.9488 196.049 71.9057C196.035 71.8627 196.022 71.7953 196.009 71.7032C195.855 71.8576 195.702 71.9676 195.55 72.0336C195.343 72.1216 195.102 72.1656 194.827 72.1656C194.462 72.1656 194.185 72.0776 193.996 71.9011C193.807 71.7252 193.712 71.5079 193.712 71.2495C193.712 71.0075 193.78 70.8082 193.917 70.6519C194.053 70.4956 194.305 70.3797 194.672 70.3036C195.111 70.2115 195.397 70.1469 195.528 70.1097C195.658 70.0731 195.796 70.0245 195.943 69.964C195.943 69.8137 195.913 69.7087 195.853 69.6487C195.794 69.5887 195.689 69.5584 195.54 69.5584C195.348 69.5584 195.203 69.5905 195.107 69.6547C195.032 69.7046 194.972 69.799 194.926 69.937V69.9379ZM195.943 70.5804C195.782 70.6404 195.614 70.6936 195.439 70.7394C195.201 70.8054 195.05 70.8705 194.987 70.9346C194.921 71.0006 194.889 71.0758 194.889 71.1597C194.889 71.2559 194.921 71.3343 194.985 71.3952C195.05 71.4562 195.144 71.4869 195.269 71.4869C195.394 71.4869 195.521 71.4539 195.634 71.3879C195.746 71.3219 195.826 71.2412 195.873 71.1459C195.92 71.051 195.943 70.9273 195.943 70.7752V70.5799V70.5804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.034 67.6914H201.21V72.0941H200.034V67.6914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.84 68.905H203.078L203.709 71.0282L204.295 68.905H205.451L204.236 72.3128C204.098 72.7014 203.957 72.964 203.813 73.1001C203.61 73.2921 203.3 73.3888 202.883 73.3888C202.714 73.3888 202.453 73.365 202.1 73.3169L202.008 72.464C202.177 72.5199 202.365 72.5479 202.572 72.5479C202.71 72.5479 202.822 72.5149 202.908 72.4484C202.993 72.3824 203.065 72.2642 203.125 72.0937L201.841 68.905H201.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.127 68.9058H197.954V72.0949H199.127V68.9058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.54 68.6894C198.897 68.6894 199.186 68.388 199.186 68.0162C199.186 67.6444 198.897 67.343 198.54 67.343C198.184 67.343 197.894 67.6444 197.894 68.0162C197.894 68.388 198.184 68.6894 198.54 68.6894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.211 81.2641L173.941 84.5257C173.841 84.561 173.723 84.5097 173.723 84.4304V65.4641C173.723 65.3857 173.839 65.3344 173.939 65.3683L183.211 68.5222V81.2641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.598 68.5286L185.769 65.1772V84.7205L183.598 81.2642V68.5286Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5323_44619",
    x: 172.9,
    y: 64.2996,
    width: 34.1,
    height: 21.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5323_44619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5323_44619",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5323_44619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.5,
    height: 19.7,
    fill: "white",
    transform: "translate(173.7 65.0996)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstall6);
export default __webpack_public_path__ + "static/media/ic-install-6.ccbb31604919418be05fd3287e24e874.svg";
export { ForwardRef as ReactComponent };